import React, { memo, useCallback } from 'react';
import { View, Text } from 'react-native';
import { rem } from 'design-system';
import { useAppSelector } from 'store/hooks';
import useIsTablet from 'hooks/useIsTablet';
import { selectTabsPriority } from 'reducers/selectors/organiseTabs';
import { IconFatPlus } from 'design-system/icons';
import AvatarFeed from 'features/feed/components/avatar-feed/AvatarFeed';
import NavigationHeaderRightIconButton from 'design-system/NavigationHeaderRightIconButton';
import { useNativeStackScreenOptions } from 'hooks/navigation/useStackNavigatorScreenOptions';
import { TAB_SCREEN_HEADER_HEIGHT } from 'navigators/styles';
import { useMainStackNavigation } from 'utils/types/navigationV6';
import createStyleSheets from 'utils/createStyleSheets';
import useStyles from 'hooks/useStyles';
import { AVATAR_SIZE } from 'features/feed/components/avatar-feed/constants';
const RecurringTabHeader = () => {
    const styles = useStyles(styleSet);
    const { hideTabNavigation } = useAppSelector(selectTabsPriority);
    const isTablet = useIsTablet();
    const globalScreenOptions = useNativeStackScreenOptions();
    const navigation = useMainStackNavigation();
    const openSearch = useCallback(() => {
        navigation.navigateDeprecated('SubscriptionsSearch', {
            empty: {
                title: 'Add a recurring payment',
                subtitle: 'Search through your transactions and select a recurring payment.\nIt works like magic!',
            },
        });
    }, []);
    return (<View style={styles.container}>
      <View style={styles.sideContainer}>
        {isTablet && !hideTabNavigation ? null : <AvatarFeed />}
      </View>

      <View style={styles.titleContainer}>
        <Text style={[globalScreenOptions.headerTitleStyle, styles.title]}>
          Recurring payments
        </Text>
      </View>

      <View style={styles.sideContainer}>
        <NavigationHeaderRightIconButton onPress={openSearch} style={styles.alignRight}>
          <IconFatPlus colorKey="primary"/>
        </NavigationHeaderRightIconButton>
      </View>
    </View>);
};
const styleSet = createStyleSheets((colors) => ({
    container: {
        flexDirection: 'row',
        alignItems: 'center',
        justifyContent: 'space-between',
        paddingHorizontal: rem(16),
        height: TAB_SCREEN_HEADER_HEIGHT,
    },
    titleContainer: {
        flex: 1,
        alignItems: 'center',
        justifyContent: 'center',
    },
    title: {
        color: colors.text.primary,
    },
    sideContainer: {
        width: rem(AVATAR_SIZE + 20),
        justifyContent: 'center',
    },
    alignRight: {
        alignSelf: 'flex-end',
    },
}));
export default memo(RecurringTabHeader);
